document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper(".loupes-slider__container", {
    spaceBetween: 30,
    effect: "fade",
    loop: false,
    navigation: {
      nextEl: ".next",
      prevEl: ".prev",
    },
    on: {
      init: function () {
        var index = this.activeIndex;
        var slides = document.querySelectorAll(".loupes-slider__item");
        var target = slides[index].dataset.target;

        document.querySelectorAll(".order-img__item").forEach(function (el) {
          el.classList.remove("active");
        });

        var activeImg = document.querySelector(
          '.order-img__item#' + target
        );
        if (activeImg) activeImg.classList.add("active");
      },
    },
  });

  swiper.on("slideChange", function () {
    var index = this.activeIndex;
    var slides = document.querySelectorAll(".loupes-slider__item");
    var target = slides[index].dataset.target;

    document.querySelectorAll(".order-img__item").forEach(function (el) {
      el.classList.remove("active");
    });

    var activeImg = document.querySelector(
      '.order-img__item#' + target
    );
    if (activeImg) activeImg.classList.add("active");

    var prevBtn = document.querySelector(".prev");
    var nextBtn = document.querySelector(".next");

    if (this.isEnd) {
      if (prevBtn) prevBtn.classList.remove("disabled");
      if (nextBtn) nextBtn.classList.add("disabled");
    } else {
      if (nextBtn) nextBtn.classList.remove("disabled");
    }

    if (this.isBeginning) {
      if (prevBtn) prevBtn.classList.add("disabled");
    } else {
      if (prevBtn) prevBtn.classList.remove("disabled");
    }
  });
});
